import React from 'react';

import { SvgComponent } from '@/types/modules/svg.types';

export const ListArrowDown: SvgComponent = (props) => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="M8 10L12 14L16 10" stroke="currentColor" strokeWidth="2" />
	</svg>
);
